export default __webpack_public_path__ + "static/media/speakers-hero-mobile.8ab0fa19.png";